"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotTrackingError = exports.LotTrackingErrorCodes = void 0;
const errors_1 = require("@deliverr/errors");
var LotTrackingErrorCodes;
(function (LotTrackingErrorCodes) {
    LotTrackingErrorCodes["DUPLICATE_REQUEST"] = "DUPLICATE_REQUEST";
    LotTrackingErrorCodes["FILE_TOO_BIG"] = "FILE_TOO_BIG";
    LotTrackingErrorCodes["INVALID_FILE"] = "INVALID_FILE";
    LotTrackingErrorCodes["INVALID_FILE_TYPE"] = "INVALID_FILE_TYPE";
    LotTrackingErrorCodes["INVALID_INPUT"] = "INVALID_INPUT";
    LotTrackingErrorCodes["INVALID_STOP_SHIP_BY_DAYS"] = "INVALID_STOP_SHIP_BY_DAYS";
    LotTrackingErrorCodes["LOT_QUARANTINED_BY_SSD"] = "LOT_QUARANTINED_BY_SSD";
    LotTrackingErrorCodes["MISSING_MSKU"] = "MISSING_MSKU";
    LotTrackingErrorCodes["MULTIPLE_PRODUCTS_FOR_A_MSKU"] = "MULTIPLE_PRODUCTS_FOR_A_MSKU";
    LotTrackingErrorCodes["NO_INVENTORY_AVAILABLE"] = "NO_INVENTORY_AVAILABLE";
    LotTrackingErrorCodes["NOT_ENABLED_FOR_FEFO_LOT_TRACKING"] = "NOT_ENABLED_FOR_FEFO_LOT_TRACKING";
    LotTrackingErrorCodes["NOT_FOUND"] = "NOT_FOUND";
    LotTrackingErrorCodes["NOT_IN_PREREQUISITE_STATE"] = "NOT_IN_PREREQUISITE_STATE";
    LotTrackingErrorCodes["PRODUCT_NOT_ENABLED_FOR_FEFO"] = "PRODUCT_NOT_ENABLED_FOR_FEFO";
    LotTrackingErrorCodes["PRODUCT_NOT_FOUND"] = "PRODUCT_NOT_FOUND";
    LotTrackingErrorCodes["STOP_SHIP_BY_DAYS_OUT_OF_RANGE"] = "STOP_SHIP_BY_DAYS_OUT_OF_RANGE";
    LotTrackingErrorCodes["UNAUTHORIZED"] = "UNAUTHORIZED";
    LotTrackingErrorCodes["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    LotTrackingErrorCodes["ZENDESK_ERROR"] = "ZENDESK_ERROR";
})(LotTrackingErrorCodes = exports.LotTrackingErrorCodes || (exports.LotTrackingErrorCodes = {}));
/**
 * An implementation of the AbstractDeliverrError that strongly types the
 * code to the LotTrackingErrorCodes enum, and that serializes both code and
 * message to JSON.
 */
class LotTrackingError extends errors_1.AbstractDeliverrError {
    toJSON() {
        return {
            code: this.code,
            message: this.message,
            cause: this.cause,
        };
    }
}
exports.LotTrackingError = LotTrackingError;
//# sourceMappingURL=LotTrackingErrors.js.map